/**
 * The overview's route and its campaign-nav entry, registered by existing:
 * `../routes.ts` discovers this file and reads its `bundle` export.
 */

import { createElement, type ReactNode } from 'react';
import { Map as MapIcon } from 'lucide-react';
import { useParams } from '@tanstack/react-router';

import type { RouteBundle } from '../../routes/contract';
import { useCampaignOrganisationId } from '../../session/orgContext';
import { FirstDataGate } from '../first-data/FirstDataGate';
import { ov } from './messages';
import { Overview } from './Overview';
import { OVERVIEW_PATH } from './paths';

const CONTROL_PLANE_READ = 'control_plane.read';

function OverviewRoute(): ReactNode {
  const { campaignId } = useParams({ strict: false }) as { campaignId?: string };
  const tenantId = useCampaignOrganisationId();
  if (tenantId === null) return null;
  return createElement(FirstDataGate, {
    campaignId: campaignId ?? '',
    tenantId,
    children: createElement(Overview, { campaignId: campaignId ?? '', tenantId }),
  });
}

export const bundle: RouteBundle = {
  routes: [
    {
      path: OVERVIEW_PATH,
      element: createElement(OverviewRoute),
      requires: CONTROL_PLANE_READ,
      kind: 'data',
    },
  ],
  nav: [],
  campaignNav: [
    {
      path: OVERVIEW_PATH,
      label: () => ov('heading'),
      requires: CONTROL_PLANE_READ,
      icon: MapIcon,
      order: 20,
      kind: 'data',
    },
  ],
};
